import { post, get } from '../axios'

// 新增冷暖区
export function theme_coldWarm_add_post(map, option) {
  return post(
    `${process.env.VUE_APP_COMMON}/theme/coldWarm/add`,
    map,
    option
  ).then(response => response)
}

// 删除冷暖区
export function theme_coldWarm_delete_id_delete(map, option) {
  return post(
    `${process.env.VUE_APP_COMMON}/theme/coldWarm/delete/${map.id}`,
    map,
    option
  ).then(response => response)
}

// 冷暖区详情
export function theme_coldWarm_detail_id_get(map, option) {
  return get(
    `${process.env.VUE_APP_COMMON}/theme/coldWarm/detail/${map.id}`,
    map,
    option
  ).then(response => response)
}

// 编辑冷暖区
export function theme_coldWarm_edit_post(map, option) {
  return post(
    `${process.env.VUE_APP_COMMON}/theme/coldWarm/edit`,
    map,
    option
  ).then(response => response)
}

// 冷暖区状态修改
export function theme_coldWarm_enable_post(map, option) {
  return post(
    `${process.env.VUE_APP_COMMON}/theme/coldWarm/enable`,
    map,
    option
  ).then(response => response)
}

// 冷暖区分页列表
export function theme_coldWarm_page_get(map, option) {
  return get(
    `${process.env.VUE_APP_COMMON}/theme/coldWarm/page`,
    map,
    option
  ).then(response => response)
}

// 主题列表（新增时查询用）
export function theme_coldWarm_themeList_get(map, option) {
  return get(
    `${process.env.VUE_APP_COMMON}/theme/coldWarm/themeList`,
    map,
    option
  ).then(response => response)
}
